<template>
  <div>
    <!-- 通用领取开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <p class="actModules_descripe line" v-html="modulesRules"></p>
      <div class="actSlider">
        <div class="actSlider_tab_h" :class="'actSlider_tab-' + tabSize">
          <a
            href="javascript:;"
            class="actSlider_tabItems_h"
            :class="{ active: activeIndex == index }"
            v-for="(tabItem, index) in tabItems"
            :key="tabItem.index"
            @click="tabSlider(index), (activeIndex = index)"
            >{{ tabItems[index].tabText }}</a
          >
        </div>
        <div class="actSlider_content_h">
          <!-- <div class='actSlider_contentWrap'>
						<div class='actSlider_contentItems_h'>
							<img v-if="tabItems[activeIndex].image" :src="tabItems[activeIndex].image">
						</div>
					</div>
					<div class='actModules_btnWrap'>
						<a href='javascript:;' @click="doAction" class='actModules_btn'>{{tabItems[activeIndex].buttonName}}</a>
					</div> -->
          <div class="swiper-container sellBanner" id="banner">
            <swiper
              class="swiper-wrapper swiper-no-swiping"
              :options="swiperOption"
              ref="mySwiper"
            >
              <swiperSlide
                class="swiper-slide"
                v-for="(tabItem, index) in tabItems"
                :key="index"
              >
                <div class="actSlider_contentItems_h">
                  <img :src="tabItem.image.value" />
                </div>
              </swiperSlide>
            </swiper>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 通用领取结束-->
  </div>
</template>

<script>
import '../../assets/css/reset.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
	name: 'h5-four-horizontal-nobtn',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			bgImg: '背景图片',
			modulesRules: '规则描述',
			tabItems: '选项',
			name: '名称',
			image: '图片',
			action: '动作',
			tabText: 'Tab文案',
			buttonName: '按钮文案'
		}
	},
	components: {
		swiper,
		swiperSlide
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字'
		},
		bgImg: {
			type: String,
			default: ''
		},
		modulesRules: {
			type: String,
			default:
        '活动规则：规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案'
		},
		tabItems: {
			type: Array,
			default () {
				return [
					{
						tabText: '1',
						image: {
							class: 'image',
							value: ''
						}
					},
					{
						tabText: '2',
						image: {
							class: 'image',
							value: ''
						}
					},
					{
						tabText: '3',
						image: {
							class: 'image',
							value: ''
						}
					},
					{
						tabText: '4',
						image: {
							class: 'image',
							value: ''
						}
					}
				];
			}
		}
	},
	data () {
		const that = this;
		return {
			activeIndex: 0,
			tabSize: 4,
			contentIndex: '1',
			swiperOption: {
				loop: false,
				on: {
					slideChangeTransitionEnd: function () {
						that.activeIndex = this.activeIndex;
					}
				}
			}
		};
	},
	computed: {
		cssDisables (idx) {
			if (this.tabItems[idx]['action']['value'] !== '') {
			} else {
				return false;
			}
		},
		swiper () {
			return this.$refs.mySwiper.swiper;
		}
	},
	mounted () {},
	methods: {
		doAction () {
			const itemConf = this.tabItems[this.activeIndex];
			this.$doAction(itemConf.action.type, itemConf.action.value)
				.then(({ sPackageName }) => {
					if (sPackageName) {
						alert(`恭喜你获得了${sPackageName}，请到游戏中查收`);
					}
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
		},
		tabSlider: function (e) {
			this.contentIndex = e;
			this.swiper.slideTo(this.contentIndex);
		}
	}
};
</script>
<style>
@import "../../assets/css/reset.css";
@import "swiper/dist/css/swiper.css";
</style>
<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common";

.actSlider {
  width: 7.3rem;
  margin: 0.1rem auto 0;

  &.one {
    height: 3.8rem;
  }

  img {
    width: 100%;
  }
}

.actSlider_tab_h {
  @extend %clearfix;

  &.actSlider_tab-7 {
    .actSlider_tabItems_h {
      width: 14.285%;
    }
  }

  &.actSlider_tab-6 {
    .actSlider_tabItems_h {
      width: 16.66666%;
    }
  }

  &.actSlider_tab-5 {
    .actSlider_tabItems_h {
      width: 20%;
    }
  }

  &.actSlider_tab-4 {
    .actSlider_tabItems_h {
      width: 25%;
    }
  }

  &.actSlider_tab-3 {
    .actSlider_tabItems_h {
      width: 33.33333%;
    }
  }

  &.actSlider_tab-2 {
    .actSlider_tabItems_h {
      width: 50%;
    }
  }
  &.actSlider_tab-1 {
    .actSlider_tabItems_h {
      width: 100%;
    }
  }
}

.actSlider_tabItems_h {
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.24rem;
  text-align: center;
  background: #a4a4a4;
  color: #4a4a4a;
  @extend %block;
  @extend %left;
  border: 1px solid #666666;

  &.active {
    background: #d8d8d8;
  }
}

.actSlider_contentItems_h {
  width: 6.9rem;
  height: 3rem;
  margin: 0.3rem auto 0;

  img {
    width: 100%;
    height: 100%;
  }
}

.actSlider_content_h {
  width: 7.3rem;
}

.actSlider_contentWrap {
  padding: 0.2rem;
  background: #d8d8d8;
}

.disabled {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/receive-h-noBtn/x-four-horizontal-nobtn.vue